
import { Component, Vue, Watch, Prop, Ref } from 'nuxt-property-decorator';
import { type NestedPage, PageType } from '../../../services/fourwaves/models';
import WebsiteNavigationNestedLink from './WebsiteNavigationNestedLink.vue';
import WebsiteNavigationNestedDropdown from './WebsiteNavigationNestedDropdown.vue';
import { v4 as uuid } from 'uuid';

@Component({
  components: { WebsiteNavigationNestedLink, WebsiteNavigationNestedDropdown },
})
export default class WebsiteNavigationDropdown extends Vue {
  @Prop({ type: Array, required: true }) readonly pages!: NestedPage[];
  @Prop({ type: Number, default: 0 }) tabIndex!: number;
  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  @Ref() readonly dropdownContainer?: HTMLElement;

  readonly PageType = PageType;

  uniqueId = uuid();
  isDropdownOpen = false;

  @Watch('$route.path')
  onRouteChanged(): void {
    this.isDropdownOpen = false;
  }

  public dropdownShowHandler(): void {
    this.dropdownContainer?.querySelector('.v-popper__popper')?.removeAttribute('tabindex');
  }
}
